module.exports = __webpack_public_path__ + "static/media/play.1e2435f7.png";